import { render } from "./TheHeadersider.vue?vue&type=template&id=74075963"
import script from "./TheHeadersider.vue?vue&type=script&lang=js"
export * from "./TheHeadersider.vue?vue&type=script&lang=js"

import "./TheHeadersider.vue?vue&type=style&index=0&id=74075963&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__